<div class="activation-link-new-plans">
  <gdp-activation-link-form
    [formControl]="activationFormControl"
    [allowDiscount]="false"
    [allowWifi]="false"
  ></gdp-activation-link-form>
  <div class="submit-container">
    <button class="vox-btn vox-btn-primary" type="submit"
    [disabled]="activationFormControl.invalid" (click)="onSubmit()">
      {{'sales.activation-link.form.button' | translate}}
    </button>
  </div>
</div>

<ng-template #activationNewPlansLinkPopup let-modal>
  <gdp-copy-feedback-popup
    [title]="'sales.copy-activation-link-modal.title' | translate"
    [feedback]="'sales.copy-activation-link-modal.link-copied' | translate"
    [content]="modalContent">
    <div class="link-container">
      <a [href]="modalContent" target="_blank" rel="noopener noreferrer" class="link">{{modalContent}}</a>
    </div>
  </gdp-copy-feedback-popup>
</ng-template>
